// Македонски - mk - 马其顿语
const mk = {
  home: {
    home: 'Почетна',
    solutions: 'Решенија',
    support: 'Поддршка',
    news: 'Вести',
    aboutUs: 'За нас',
    contactUs: 'Контакт',
    cgm: 'CGM',
    download: 'Преземања',
    helpCenter: 'Центар за помош',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Сите права се задржани.',
    menu: 'Мени',
    quickLinks: 'Брзи линкови',
    contact: 'Контакт',
    legal: 'Правни информации',
    termsUse: 'Услови за користење',
    privacyPolicy: 'Политика за приватност',
    portal: 'Кориснички портал',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'Е-пошта',
    subscribe: 'Претплати се',
    signUp: 'Регистрирај се за најнови вести',
    downloadApp: 'Преземи апликација',
    blogNews: 'Блог и вести',
    latestArticles: 'Најнови статии',
    viewAllArticles: 'Види ги сите статии',
    empower: 'Подобри го твоето здравje заедно со нас',
    empowerList1Content:
      'Hippo CGM го направи управувањето со дијабетесот на мојот син многу полесно. Можеме да го користиме HIPPOLINK за јасно да ги видиме неговите гликозни модели и со доверба да ја прилагодиме неговата нега. Ни дава мир на умот.',
    empowerList1Name: 'Петра Н., Чешка (мајка на дете со дијабетес тип 1)',
    empowerList2Content:
      'Го препорачуваме HIPPO CGM на пациентите поради неговите стабилни перформанси и подолго време на користење. Повратните информации од корисниците се одлични, особено од оние кои бараат попристапна опција.',
    empowerList2Name: 'Д-р Лука Б., ендокринолог, Италија',
    empowerList3Content:
      'Неодамна почнав да го користам Hippo CGM...тој е удобен, прецизен, а известувањата ми помогнаа да избегнам ниско ниво на гликоза во текот на ноќта. Многу сум задволен од резултатите досега.',
    empowerList3Name: 'Фахад А., Саудиска Арабија (пациент со дијабетес тип 2)',
    reliable: 'Ваш сигурен партнер за управување со дијабетес',
    hippoH1: 'HiPPO H1',
    challenges: 'Предизвици',
    constant: 'Постојано следење на гликемијата во крвта',
    traditional: 'Традиционалното боцкање на прст може да биде болно',
    dataOverload: 'Преоптоварување со податоци',
    managing: 'Управувањето со податоци за гликемија е комплексно',
    treatment: 'Прилагодување на терапија',
    accurately:
      'Точното одредување на терапијата согласно читањата на гликемиите е сложено',
    lifestyle: 'Интеграција според начинот на живот',
    balancing:
      'Балансирањето на оброците, вежбањето и лековите со секојдневните активности може да биде предизвик.',
    hippoCan: 'Hippo биосензорите нудат',
    painless: 'Безболно и дискретно следење',
    ourCgm:
      'Нашиот CGM овозможува континуирано мерење на шеќерот во крвта без потреба од боцкање со прстот.',
    realTime: 'Податоци и увиди во реално време',
    accessYour:
      'Пристапете до податоците за шеќерот во крвта лесно преку вашиот паметен телефон, што ви овозможува да ги видите трендовите и да донесете одлуки',
    personalized: 'Персонализирана поддршка',
    ourCgmSys:
      'Предупредувањата и потсетниците од апликацијата Hippo BioSensors можат да ви помогнат да останете во тек со вашиот план за лекување.',
    improved: 'Подобро донесување одлуки',
    gain: 'Подлабоко разбирање за тоа како вашето тело реагира на настаните, што ви овозможува подобро да ги управувате флуктуациите на гликозата. Повратните информации во реално време ви овозможуваат поефикасно да правите прилагодувања на вашите дневни активности.',
    // about: 'За нас',
    companyProfile: 'Профил на компанијата',
    banner1Title: 'Добредојдовте во Hippo Medical',
    banner1Content: 'Во првите редови на CGM иновациите',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Поставуваме нови стандарди',
    banner3Content: '24/7 заштита на гликоза',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Лидер во CGM технологија',
    // 错误提示
    subscribeSuccess: 'Претплатата е успешна', // ai翻译
    subscribeFailed: 'Претплатата не успеа', // ai翻译
    invalidEmail: 'Невалидна е-пошта адреса', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return mk.home.banner1Title;
    },
    get banner1Content() {
      return mk.home.banner4Content;
    },
    whyChoose: 'Зошто да изберете HiPPO CGM',
    accurate: 'Прецизност на која можете да се потпрете',
    accurateText:
      'Ензимската технологија од трета генерација обезбедува повеќе',
    accurateText1: 'стабилни и точни перформанси',
    easyUse: 'Лесно за користење',
    easyUseText: '14 дена континуирано следење',
    realTime: 'Следење',
    realTimeText: 'Известувања за хипо и хипергликемија во реално време',
    realTimeText1: 'Споделување податоци во реално време',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Ве информира каде и кога било',
    withHippo: 'Со HiPPO апликации и портал',
    smallSensors: 'Мали сензори, удобно носење',
    agpReport:
      'Професионалниот извештај AGP им овозможува на здравствените работници и корисниците веднаш да ги доловат клучните информации.',
    unlimitedFollow: 'Неограничено следење',
    iWatchApp: 'iWatch апликација достапна',
    certified: 'Сертифицирано за деца',
    loremIp:
      'Системот е клинички валидиран и официјално сертифициран за педијатриска употреба кај деца над 3 години, обезбедувајќи безбедност, точност и удобност за помладите пациенти. Со докажана точност на сензорот и нежни материјали кои се погодни за кожата, тој обезбедува сигурно следење на гликозата кај деца и адолесценти - поддржувајќи ги здравствените работници во обезбедувањето доверлива грижа за дијабетес базирана на податоци.',
  },
  news: {
    date: 'Датум',
    recommendedArticles: 'Препорачани статии',
  },
  support: {
    download: 'Преземи водичи',
    supportDown: 'Поддршка/Преземања',
  },
  about: {
    welcome: 'Добредојдовте во Hippo Medical',
    covered: 'Покриени земји',
    patents: 'Патенти',
    features: 'Функции3',
    ring: 'Прстен',
    apparently:
      'Паметен прстен што може да ги следи параметрите како што се кислородот во крвта, отчукувањата на срцето и спиењето. Уште поважно, има алгоритамска врска со нашиот CGM. Лансирање во 2026 година. Останете во тек!',
    cgmSky:
      'Професионален CGM дизајниран имајќи ги предвид и употребата на пациентот и клиничките потреби на лекарот. Нуди висока точност, лесна за користење софтверска интеракција и е напојуван од алгоритмите на Hippo Medical. Лансирање во јуни 2025 година!',
    smartWatch: 'Паметен часовник',
    byTheSame:
      'Нослив  уред за крвен притисок кој може континуирано да го следи систолниот притисок, дијастолниот притисок, средниот артериски притисок и друго, со алгоритам развиен од Hippo Medical. Лансирање во 2026 година. Останете во тек!',
    explore: 'Истражи',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'СИНГАПУР (409051)',
    zipCode: 'Поштенски код',
    emailCode: '409051',
    email: 'Е-пошта',
    emailText: 'info@hippodiabetes.com',
    name: 'Име*',
    company: 'Компанија',
    message: 'Порака',
    phone: 'Телефон',
    submit: 'Испрати',
    commingSoon: 'Наскоро',
    cpInfo1:
      '„Хипо Медикал“ е глобална MedTech компанија, со седиште во Сингапур, посветена на револуција во управувањето со хронични болести со носиви биосензори од медицински квалитет. Нашата визија е да обезбедиме континуирано следење и напредна анализа на податоци.',
    cpInfo2:
      'Со развивање на биосензори од следната генерација и најсовремена платформа за интелигенција на податоци, имаме за цел да ја трансформираме дијагностиката и да го поведеме патот кон попроактивна и персонализирана иднина.',
    submitFailed: 'Испраќањето не успеа', // ai翻译
    get invalidEmail() {
      return mk.home.invalidEmail;
    },
    fillAllFields: 'Ве молиме пополнете го ова поле', // ai翻译
  },
  download: {
    language: 'Јазик',
    product: 'Производ',
    unit: 'Единица',
    fetchFailed: 'Преземањето не успеа', // ai翻译
  },
  help: {
    search: 'Пребарување',
    support: 'Поддршка/Центар за помош/H1 CGM',
    source: 'HiPPO H1 CGM онлајн ресурси',
    viewAll: 'Види сè',
    insert: 'Како да го поставите H1 CGM',
    setUp: 'Како да ја поставите H1 апликацијата',
    faq: 'HiPPO H1 CGM ЧПП',
    freq: 'Често поставувани прашања',
    noData: 'Не е пронајдена содржина..',
    searchKeys: {
      warmUp: 'Грешка во фаза на загревање',
      waterLeakage: 'Протекување вода',
      lowGlucose: 'Низок гликозен податок',
      cannotPair: 'Не може да се поврзе со телефонот',
    },
  },
  faq: {
    faq: 'ЧПП',
    general: 'Општи прашања',
    need: 'Ви треба помош?',
    here: 'Еве ги најчестите прашања',
    technical: 'Технички прашања',
  },
  lang: {
    chooseCountry: 'Изберете држава/регион',
    northAmerica: 'Северна Америка', // ai翻译
    southAmerica: 'Јужна Америка', // ai翻译
    europe: 'Европа', // ai翻译
    africa: 'Африка', // ai翻译
    asia: 'Азија', // ai翻译
    oceania: 'Океанија', // ai翻译
    other: 'Друго', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Сужоу, Кина',
      subName: 'Произ. локација',
      hovData:
        'Глобална централа R&D/центар за податоци/продажба Азија и Австралија',
    },
    dubai: {
      name: 'Дубаи',
      subName: 'Рег. канц.',
      hovData: 'Тим за продажба Југоисточна Азија',
    },
    singapore: {
      name: 'Сингапур',
      subName: 'Седиште',
      hovData: 'Тим за продажба Југоисточна Азија',
    },
    sanFrancisco: {
      name: 'Сан Франциско, САД',
      subName: 'Регионална канцеларија',
      hovData: 'Тим за продажба Северна Америка',
    },
    barcelona: {
      name: 'Барселона',
      subName: 'Продажна канцеларија',
      hovData:
        'Глобална централа R&D/центар за податоци/продажба Азија и Австралија',
    },
  },
};
export default mk;
